// extracted by mini-css-extract-plugin
export default {"mainContainer":"Alert_mainContainer__cdKJ0","mainBox":"Alert_mainBox__VQh+J","desc":"Alert_desc__kt+qI","text":"Alert_text__tjFby"};